import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=1df48480&scoped=true&"
import script from "./CreditCard.vue?vue&type=script&lang=ts&"
export * from "./CreditCard.vue?vue&type=script&lang=ts&"
import style0 from "./CreditCard.vue?vue&type=style&index=0&id=1df48480&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df48480",
  null
  
)

export default component.exports